import { createSlice } from '@reduxjs/toolkit';
import { PaymentSchema } from '../types/paymentSchema';
import { getPaymentListByRegion } from '@entities/Payment/module/services/GetPaymentListByRegion';

const initialState: PaymentSchema = {
  paymentList: [],
  isLoaded: false,
};

export const paymentSlice = createSlice({
  name: 'payment',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(getPaymentListByRegion.pending, state => {
      console.log('загрузка list payment by region');
      state.isLoaded = true;
    });
    builder.addCase(getPaymentListByRegion.fulfilled, (state, action) => {
      if (action.payload) {
        state.paymentList = action.payload;
      }
      state.isLoaded = false;
    });
    builder.addCase(getPaymentListByRegion.rejected, state => {
      state.isLoaded = false;
    });
  },
});

export const { actions: paymentActions } = paymentSlice;
